export function printLetterContent(content, title = "Medical Necessity Letter") {
  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    throw new Error("Could not open the print view. Allow pop-ups for this site and try again.");
  }
  printWindow.opener = null;
  const printDocument = printWindow.document;
  printDocument.title = title;
  const style = printDocument.createElement("style");
  style.textContent = `
    body { margin: 0; color: #000; background: #fff; }
    pre { margin: 0; white-space: pre-wrap; overflow-wrap: anywhere;
      font: 12pt/1.5 Georgia, serif; }
    @page { margin: 0.75in; }
    @media screen { body { max-width: 8in; margin: 2rem auto; padding: 1rem; } }
  `;
  const letter = printDocument.createElement("pre");
  letter.textContent = String(content);
  printDocument.head.appendChild(style);
  printDocument.body.replaceChildren(letter);
  printWindow.focus();
  printWindow.print();
}
